// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__LoadMoreProductCatalog__VirtualizedProductView__root","cell":"CentricUI__LoadMoreProductCatalog__VirtualizedProductView__cell","cellContents":"CentricUI__LoadMoreProductCatalog__VirtualizedProductView__cellContents","larger":"CentricUI__LoadMoreProductCatalog__VirtualizedProductView__larger"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/CardView/LoadMoreProductCatalog/VirtualizedProductView.css
// module id = 812
// module chunks = 10